import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		title: {
			textAlign: 'center',

			[theme.breakpoints.down('sm')]: {
				'& *': {
					textAlign: ({ metaData }) =>
						metaData.mobileAlignment?.metaValue ? `${metaData.mobileAlignment.metaValue} !important` : null,
				},
			},
		},

		container: {
			height: '100%',
			marginBottom: theme.spacing(3),
			width: '100%',
		},

		textContainer: {
			width: '100%',
			marginBottom: 0,
		},

		text: {
			textAlign: 'left',

			[theme.breakpoints.down('sm')]: {
				'& *': {
					textAlign: ({ metaData }) =>
						metaData.mobileAlignment?.metaValue ? `${metaData.mobileAlignment.metaValue} !important` : null,
				},
			},
		},
	}),
	{ name: 'Video-Video7' },
)

export default useStyles
